/* global ol */

var angular = require('angular');

function HoverRouteInteraction(map, layer, isCar) {
  this.map = map;
  this.layer = layer;
  this.isCar = isCar;

  this.layerStyle = layer.layer.getStyle();
  this.stroke = new ol.style.Stroke({
    color: 'white',
    width: 2
  });

  this.interaction = new ol.interaction.Select({
    condition: ol.events.condition.pointerMove,
    toggleCondition: ol.events.condition.never,
    layers: [this.layer.layer],
    style: []
  });

  this.interaction.on('select', this.onSelect.bind(this));

  this.clearHover = this.clearHover.bind(this);
  this.map.map.on('movestart', this.clearHover); // TODO disable hover until moveend
  angular.element(this.map.map.getViewport()).on('mouseout', this.clearHover);
}

HoverRouteInteraction.prototype.onSelect = function(event) {
  var hover = ! this.routeSelected() && !! event.selected[0];
  var siblingLayers = this.isCar ? this.map.routeLayers : this.map.carLayers;

  this.setHover(hover);
  if (siblingLayers) {
    siblingLayers[this.layer.route.id].hoverInteraction.setHover(hover);
  }
};

HoverRouteInteraction.prototype.clearHover = function() {
  if (this.hover) {
    this.interaction.getFeatures().clear();
    this.setHover(false);
  }
};

HoverRouteInteraction.prototype.setHover = function(hover) {
  if (hover !== this.hover) {
    this.hover = hover;
    this.isCar && this.layer.setHover(hover);
    this.updateClusterStyle();
    this.map.selectStyle.redrawStyle();
  }
};

HoverRouteInteraction.prototype.updateClusterStyle = function() {
  var style = this.hover ? this.hoverStyle.bind(this) : this.layerStyle;

  this.layer.layer.setStyle(style);
  this.layer.layer.setZIndex(this.hover ? 2 : 0);
};

HoverRouteInteraction.prototype.routeSelected = function() {
  return this.layer.route === this.map.scope.map.route;
};

HoverRouteInteraction.prototype.hoverStyle = function(feature, resolution) {
  var style = this.layerStyle(feature, resolution);
  var circle = style.length ? style[0] : style;

  circle.setStroke(this.stroke);

  return style;
};

module.exports = HoverRouteInteraction;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/lib/map/hoverRouteInteraction.js
 ** module id = 180
 ** module chunks = 1
 **/